import React from "react"

export default function Layout({ children }: any){

    return children
}

